export const Chevron = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--chevron';
  color = color || '#303E47';

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M6 3.33317L10.6667 7.99984L6 12.6665"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Chevron;
